var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckGreenIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.115 8.73L9.36 4.485L8.67 3.81L5.115 7.365L3.315 5.565L2.64 6.24L5.115 8.73ZM6 12C5.18 12 4.405 11.8425 3.675 11.5275C2.945 11.2125 2.3075 10.7825 1.7625 10.2375C1.2175 9.6925 0.7875 9.055 0.4725 8.325C0.1575 7.595 0 6.82 0 6C0 5.17 0.1575 4.39 0.4725 3.66C0.7875 2.93 1.2175 2.295 1.7625 1.755C2.3075 1.215 2.945 0.7875 3.675 0.4725C4.405 0.1575 5.18 0 6 0C6.83 0 7.61 0.1575 8.34 0.4725C9.07 0.7875 9.705 1.215 10.245 1.755C10.785 2.295 11.2125 2.93 11.5275 3.66C11.8425 4.39 12 5.17 12 6C12 6.82 11.8425 7.595 11.5275 8.325C11.2125 9.055 10.785 9.6925 10.245 10.2375C9.705 10.7825 9.07 11.2125 8.34 11.5275C7.61 11.8425 6.83 12 6 12Z",
    fill: "#2DB25D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckGreenIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-green-icon.867b3c55.svg";
export { ForwardRef as ReactComponent };